export const LOADING_CONTENT_TYPE = Object.freeze({
  SHARED_CONTEXT: 'shared-context',
  API_PAGE_DATA: 'api-page-data',
  LOCAL_PAGE_STATE: 'local-page-state',
  VIEW_DATA: 'view-data',

  getAll() {
    return Object.values(this).filter(value => typeof value === 'string');
  },
});
